import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import SetPassword from './pages/SetPassword';
import NotFound from './pages/NotFound';
import Profile from './pages/profile/Profile';
import PersonalTest from './pages/PersonalTest';
import TrainingSchedule from './pages/TrainingSchedule';
import Races from './pages/Races';
import TrainingLibrary from './pages/TrainingLibrary';
import TrainingVideoPlayer from './pages/TrainingVideoPlayer';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        {/* /forgot-password is intentionally not routed: passwords are set by the admin.
            ForgotPassword.tsx and the backend endpoint are kept for easy re-enabling. */}
        <Route path="/login" element={<Login />} />
        <Route path="/set-password" element={<SetPassword />} />

        {/* Protected Routes */}
        <Route path="/" element={
          <PrivateRoute>
            <Layout>
              <TrainingSchedule />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/profile" element={
          <PrivateRoute>
            <Layout>
              <Profile />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/personal-test" element={
          <PrivateRoute>
            <Layout>
              <PersonalTest />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/races" element={
          <PrivateRoute>
            <Layout>
              <Races />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/training-schedule" element={
          <PrivateRoute>
            <Layout>
              <TrainingSchedule />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/training-library" element={
          <PrivateRoute>
            <Layout>
              <TrainingLibrary />
            </Layout>
          </PrivateRoute>
        } />

        <Route path="/training-library/:id" element={
          <PrivateRoute>
            <Layout>
              <TrainingVideoPlayer />
            </Layout>
          </PrivateRoute>
        } />

        {/* 404 - Not Found */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
